import { render, staticRenderFns } from "./GeneralPathCourses.vue?vue&type=template&id=69182363&scoped=true&"
import script from "./GeneralPathCourses.vue?vue&type=script&lang=ts&"
export * from "./GeneralPathCourses.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralPathCourses.vue?vue&type=style&index=0&id=69182363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69182363",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69182363', component.options)
    } else {
      api.reload('69182363', component.options)
    }
    module.hot.accept("./GeneralPathCourses.vue?vue&type=template&id=69182363&scoped=true&", function () {
      api.rerender('69182363', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/GeneralPathCourses.vue"
export default component.exports